// Runs before React renders so no page ever auto-creates a guest over a pinned session.
const params = new URLSearchParams(window.location.search);
const as = params.get("as");
const previewPin = process.env.REACT_APP_PREVIEW_AS_TOKEN;
const onPreview = window.location.hostname.endsWith(".preview.emergentagent.com");
const isInviteRoute = /^\/(multiplayer\/match|w|p)\//.test(window.location.pathname);

const pin = (token) => {
  if (localStorage.getItem("fc_token") === token) return;
  localStorage.setItem("fc_token", token);
  localStorage.removeItem("fc_user");
};

if (as) {
  localStorage.removeItem("fc_dev_unpin");
  pin(as);
  params.delete("as");
  const qs = params.toString();
  window.history.replaceState({}, "", window.location.pathname + (qs ? `?${qs}` : ""));
} else if (previewPin && onPreview && !isInviteRoute && !localStorage.getItem("fc_dev_unpin")) {
  pin(previewPin);
}

export const isPreview = onPreview && !!previewPin;

export const switchToPinned = () => {
  localStorage.removeItem("fc_dev_unpin");
  localStorage.setItem("fc_token", previewPin);
  localStorage.removeItem("fc_user");
  window.location.assign("/");
};

export const switchToFreshGuest = () => {
  localStorage.setItem("fc_dev_unpin", "1");
  localStorage.removeItem("fc_token");
  localStorage.removeItem("fc_user");
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`, { method: "POST", credentials: "include" }).finally(() => window.location.assign("/"));
};
